/*
 * @FilePath     : /es-template/src/store/modules/user/state.js
 * @Author       : LiYang
 * @Date         : 2021-08-26 10:48:19
 * @LastEditTime : 2022-01-04 16:13:35
 * @LastEditors  : Please set LastEditors
 * @Description  :
 */
export default {
  selectedContact: [],
  travelerListForLoginPage: [],
}